import { render, staticRenderFns } from "./CustomContentTabs.vue?vue&type=template&id=0a20a33c"
import script from "./CustomContentTabs.vue?vue&type=script&lang=js"
export * from "./CustomContentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports